import LinkToTransactionDetails from './LinkToTransactionDetails';
export default LinkToTransactionDetails;
